import type { PropsWithChildren } from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../../auth/AuthProvider";
import { LoadingBlock } from "../common/LoadingBlock";
import { StatusBanner } from "../common/StatusBanner";

export function AdminGuard({ children }: PropsWithChildren) {
  const auth = useAuth();

  if (auth.isLoading) {
    return (
      <main className="admin-shell admin-shell--centered">
        <LoadingBlock label="Verifica accesso amministratore..." />
      </main>
    );
  }

  if (!auth.session) {
    return <Navigate to="/admin/login" replace />;
  }

  if (!auth.isAdmin) {
    return (
      <main className="admin-shell admin-shell--centered">
        <section className="admin-card admin-card--compact">
          <StatusBanner
            tone="error"
            message="L'utente autenticato non è autorizzato ad accedere all'area admin."
          />
          <button className="primary-button" type="button" onClick={() => auth.signOut()}>
            Esci
          </button>
        </section>
      </main>
    );
  }

  return <>{children}</>;
}
